export default __webpack_public_path__ + "static/media/bmw.88e6410f.webp";